export default "<p>compteur works!</p>\n"